<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2 data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1200">E-Commerce</h2>
            <ul data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1200">
                <li><a routerLink="/">Home</a></li>
                <li>E-Commerce</li>
            </ul>
        </div>
    </div>

</div>
<!-- End Page Title Area -->

<!-- Start E-Commerce Area -->
<!-- <div class="aboutus-hb__control_panel">
    <div class="aboutus-hb__yearline">
        <div class="aboutus-hb__yearline_track">
            <div
            class="page-heading"
            style="
                height: 150px;
                text-align: center;
                color: #000000;
                margin-bottom: 40px;
                text-transform: uppercase;
            "
        >
            <h1>
                <b
                    >E-Commerce Solutions: VOCBot Tackles Key Challenges Effectively</b
                >
            </h1>
             
        </div>
        </div>
    </div>
     
</div> -->

<section class="team-area ">
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <!-- <div class="col-lg-12 col-md-12 col-sm-12">
                   
                </div> -->
                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class=" ai-solution-wrap-image">
                        <img src="assets/img/young-man-enhancing-his-skill.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class=" ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Enhancing the Customer Experience
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Surveys state that over “60% of D2C consumer's IVR calls result in poor customer experience
                            due to long waiting times and limited assistance options.”
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class=" ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Enhance Customer Retention
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Customer retention can contribute up to 80% of the revenue at 1/5th of the acquisition cost.
                            Vocbot enhances the customer experience, resulting in a higher customer retention rate.
                        </p>
                    </div>
                </div>
                <div class="media  col-lg-5 col-md-6 col-sm-12">
                    <div class="  ai-solution-wrap-image">
                        <img src="assets/img/e-commerce-customer-service-agent.png" alt="image" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">



                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="   ai-solution-wrap-image">
                        <img src="assets/img/ecommerce-cart.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class=" ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Shopping Cart Abandonment
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            It is a prevalent challenge in e-commerce that can be resolved with Vocbot by ensuring a
                            smoother customer journey and higher conversion rates.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class=" text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class=" ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Minimizing CoD Order Cancellation
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Vocbot reduces the COD order cancellation rate by verifying order details before they are
                            dispatched, making confirmation calls, sending regular delivery updates, sending payment
                            reminders, and collecting feedback using interactive calls.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="   ai-solution-wrap-image">
                        <img src="assets/img/ecommerce-CoD.png" alt="image" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">



                <div class="media  col-lg-5 col-md-6 col-sm-12">
                    <div class="  ai-solution-wrap-image">
                        <img src="assets/img/delivery-customer-service.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class=" ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            On-Call Order Placement Services
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Simplify the order placement process with Vocbot’s real-time interactive calls, ensuring a
                            seamless customer experience.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class=" ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Optimizing Timely Feedback Collection
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Traditional feedback methods heavily rely on customers to
                            actively open a web link and share their feedback, limiting
                            the collection from a majority of customers.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="   ai-solution-wrap-image">
                        <img src="assets/img/ecommerce-feedback.png" alt="image" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">

                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="   ai-solution-wrap-image">
                        <img src="assets/img/ecommerce-presen.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class=" ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Unified Presence Across Channels
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Establishing a strong presence across various channels is
                            crucial for reaching a wider audience and ensuring a
                            seamless experience.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>


</section>